
import AppHeader from '@/components/Header.vue'
import { defineComponent, computed, ref, getCurrentInstance, onMounted} from 'vue';
import { Icon, Toast } from 'vant';
import { PullRefresh, Field, Uploader} from 'vant';
import { uploadImages } from '@/apis/service';
import { useStore } from 'vuex';
import { appealAllProtect, appealDzProtect} from '@/apis/service';
import Compressor from 'compressorjs';
export default defineComponent({
  name: 'ServiceDetail',
  components: {
    AppHeader,
    vanIcon: Icon,
    vanPullRefresh: PullRefresh,
    vanField: Field,
    vanUploader: Uploader
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const loading = ref(false);
    const fileList = ref([]);
    const imagesGuidList = ref([]);
    const description = ref('');
    const store = useStore(); // vuestore
    const indexSelectLog: any = computed(() => {
      return store.getters.getAppealSelectLog;
    });
    const pagePaddingTop = computed(() => store.getters.pagePaddingTop);
    const btnCanbeSubmit = computed(() => {
      return description.value.length >= 1;
    });
    const onRefresh = ()=>{
      loading.value = false;
    };
    const handleSelectDatePage = () => {
      store.commit('setAppealDescAndImage', {imageBase64List: fileList.value, description: description});
      proxy.$router.replace({path: `/selectdate/${proxy.$route.params.sn}/${proxy.$route.params.guid}/${proxy.$route.params.type}`})
    };
    // 图片压缩
    const imageCompress = async (file: File) => {
      return new Promise((resolve, reject) => {
         new Compressor(file, {
          quality: 0.8,
          maxWidth: 4096,
          maxHeight: 4096,
          checkOrientation: false,
          success(result) {
            resolve({
              type: "success",
              file: result
            });
          },
          error(err) {
            reject({
              type: 'error',
              msg: err.message
            })
          },
        });
      })
    }
    // 上传图片
    const uploadImage = async () => {
      for(let i = 0; i < fileList.value.length; i++) {
        fileList.value[i].status = 'uploading';
        fileList.value[i].status = '上传中...';
      }
      let param = new FormData();
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      for(let i = 0; i < fileList.value.length; i++) {
        let indexResult: any = await imageCompress(fileList.value[i].file)
        if(indexResult.type == 'success') {
          param.append(`images[${i}]`, indexResult.file);
        }
      }
      try {
        let result: any = await uploadImages(param);
        toast.clear();
        // 将图片添加到列表
        for(let i = 0; i < result.length; i++) {
          imagesGuidList.value.push(result[i]);
        }
      } catch (error: any) {
        let message = error && error.message ? error.message : '上传图片失败！';
        toast.clear();
        Toast(message);
      }
    };
    // 提交全保审核/定责审核
    const handleAppealProtect = async () => {
      if(fileList.value.length >= 1) {
        await uploadImage();
      } 
      let logs = [];
      for(let i = 0; i < indexSelectLog.value.length; i++) {
        logs.push(indexSelectLog.value[i].guid);
      }
      let param  = {
        images: imagesGuidList.value,
        logs: logs,
        description: description.value,
        flight_at: '',
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      if(proxy.$route.params.type == '1') {
        try {
          let result = await appealAllProtect(proxy.$route.params.guid as string, param);
          toast.clear();
          Toast('申诉提交完成!');
          proxy.$router.go(-1);
        }catch(error: any) {
          let message = error && error.message ? error.message : '提交申诉失败，请检查网络';
          toast.clear();
          Toast(message);
        }
      }
      if(proxy.$route.params.type == '2') {
        try {
          let result = await appealDzProtect(proxy.$route.params.guid as string, param)
          toast.clear();
          Toast('申诉提交完成!');
          proxy.$router.go(-1);
        } catch (error: any) {
        let message = error && error.message ? error.message : '提交申诉失败，请检查网络!';
        toast.clear();
        Toast(message);
        }
        
      }
    };
    // 提交定责审核
    const beforeDelete = (file: any, detail: any) => {
      imagesGuidList.value.splice(detail.index, 1);
      return true;
    };
    // 还原store的数据状态
    onMounted(() => {
      description.value = store.getters.getAppealProtectDesciption;
      fileList.value = store.getters.getAppealAllProtectImage;
    });
    return {
      loading,
      fileList,
      description,
      imagesGuidList,
      indexSelectLog,
      btnCanbeSubmit,
      pagePaddingTop,
      onRefresh,
      handleSelectDatePage,
      beforeDelete,
      handleAppealProtect
    }
  },
  methods: {
   
  }
})
